import { ConnectAccountsCta } from "@components/billing/PlanManagement/ConnectAccountsCta";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { FC } from "react";
import {
    CATALOG_ITEM_CREATE_CTA_SUBTITLE,
    CATALOG_ITEM_CREATE_CTA_TITLE,
    CatalogItemCreateButton,
} from "./catalogItemEmptyCta";

type CatalogItemsEmptyViewVariant = "filtered" | "create";

interface CatalogItemsEmptyViewProps {
    variant: CatalogItemsEmptyViewVariant;
    onClearFilters: () => void;
    onAddItem: () => void;
}

export const CatalogItemsEmptyView: FC<CatalogItemsEmptyViewProps> = ({
    variant,
    onClearFilters,
    onAddItem,
}) => {
    if (variant === "filtered") {
        return (
            <EmptyState
                header="The filters don't match any items."
                action={onClearFilters}
            />
        );
    }

    return (
        <ConnectAccountsCta
            title={CATALOG_ITEM_CREATE_CTA_TITLE}
            subtitle={CATALOG_ITEM_CREATE_CTA_SUBTITLE}
        >
            <CatalogItemCreateButton onAddItem={onAddItem} />
        </ConnectAccountsCta>
    );
};
